export const META_FALLBACKS = Object.freeze({
  title: 'Caregiving.com | For Family Caregivers By Family Caregivers',
  image: 'https://images.caregiving.com/unsafe/pr:banner/plain/posts/694faad7-764b-4444-983f-68b7777ffc7c/caregiving-couple-walking.jpg',
  description: 'We at Caregiving.com are here to care for you as you care for family and friends. Explore our articles written for family caregivers by family caregivers.'
})